
import { BaseVue } from "@newview/base-web";
import { Component, Watch,Prop } from "vue-property-decorator"; 
@Component({
  name: "noFondPage",
  components: {
  },
})
export default class noFondPage extends BaseVue {  
}
